import React from "react";
import { 
  Grid, 
  TextField, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Tooltip, 
  IconButton, 
  Button,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";

const TerminalsFields = ({ 
  formData, 
  handleTerminalChange, 
  handleDeleteTerminal,
  handleAddTerminal,
  submittedSteps,
  invalidFields,
  setSeverity,
  setMessageOpen,
  setSnackOpen
}) => {
  return (
    <>
      {formData.acquirer.terminal.terminals.map((terminal, index) => {
        return (
          <Grid item xs={10} key={index}>
            <Grid container spacing={3}>
              {/* Terminal Type */}
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel 
                      id="terminal-type-label"
                      required
                      sx={{
                          '& .MuiFormLabel-asterisk': {
                            color: 'red',
                            fontSize: '1.2rem',
                      }
                    }}
                  >
                          Terminal Type
                    <Tooltip title={'Terminal Type'} arrow>
                      <IconButton size="small" sx={{ padding: 0, marginLeft: '4px' }}>
                        <InfoIcon color="primary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputLabel>
                  <Select
                    labelId={`terminal-type-label-${index}`}
                    value={terminal.terminalType}
                    label="Terminal Type"
                    onChange={(e) => {
                      const newType = e.target.value;
                      const hasEcommerce = formData.acquirer.terminal.terminals.some(
                        (t, i) => i !== index && t.terminalType === "E"
                      );
                    
                      if (newType === "E" && hasEcommerce) {
                        let errorMessage = "Only one eCommerce type terminal is allowed per merchant!";
                        setSeverity("error");
                        setMessageOpen(errorMessage);
                        setSnackOpen(true);
                        return;
                      }
                    
                      handleTerminalChange(index, "terminalType", newType);
                    }}
                    required
                  >
                    <MenuItem value="A">ATM = A</MenuItem>
                    <MenuItem value="C">COTS (Phone/Tablet) = C</MenuItem>
                    <MenuItem value="E">eCommerce = E</MenuItem>
                    <MenuItem value="R">ECR = R</MenuItem>
                    <MenuItem value="I">App = I</MenuItem>
                    <MenuItem value="K">Kiosk = K</MenuItem>
                    <MenuItem value="M">mPOS = M</MenuItem>
                    <MenuItem value="P">POS = P</MenuItem>
                    <MenuItem value="T">Teller = T</MenuItem>
                    <MenuItem value="V">Vending Machine = V</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Terminal Serial */}
              <Grid item xs={4}>
                <TextField
                  label={
                    <>
                      Terminal Serial
                      <Tooltip title={"Terminal Serial"} arrow>
                        <IconButton size="small" sx={{ padding: 0, marginLeft: '4px' }}>
                          <InfoIcon color="primary" fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </>
                  }
                  value={terminal.terminalSerial || ""}
                  onChange={(e) => {
                    handleTerminalChange(index, "terminalSerial", e.target.value);
                  }}
                  fullWidth
                  required
                  inputProps={{ 
                    maxLength: 30,
                  }}
                  InputLabelProps={{ 
                    sx: {
                      '& .MuiFormLabel-asterisk': {
                        color: 'red',
                        fontSize: '1.2rem',
                      }
                    }
                  }}
                />
              </Grid>

              <Grid item xs={4} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton
                  onClick={() => handleDeleteTerminal(index)}
                  disabled={formData.acquirer.terminal.terminals.length === 1}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        );
      })}
      <Grid item xs={2} sx={{ alignSelf: "center" }}>
        <Button 
          variant="contained" 
          sx={{
            whiteSpace: "nowrap", 
            minWidth: 140,        
          }}
          onClick={() => {
            handleAddTerminal({
              terminalType: "", 
              terminalID: "",
              terminalSerial: ""
            });
          }}
        >
          Add Terminal
        </Button>
      </Grid>
    </>
  );
};

export default TerminalsFields;
